import {
  APP_BRAND_NAMES,
  APP_BRAND_SUPPORT_EMAILS,
  APP_BRAND_SUPPORT_PHONES,
  useAppBrand
} from '@vivaldis/common'
import { useEffect } from 'react'

import i18n from '../../i18n'

export const AppBrandI18nSync = () => {
  const appBrand = useAppBrand()

  useEffect(() => {
    if (i18n.options.supportedLngs) {
      i18n.options.supportedLngs?.forEach(language => {
        const resources = {
          brand_name: APP_BRAND_NAMES[appBrand],
          brand_support_email: APP_BRAND_SUPPORT_EMAILS[appBrand],
          brand_support_phone: APP_BRAND_SUPPORT_PHONES[appBrand]
        }

        Object.entries(resources).forEach(([key, value]) => {
          i18n.addResource(language, 'common', key, value)
        })
      })
      i18n.emit('languageChanged', i18n.language)
    }
  }, [appBrand])

  return null
}
